module.exports = __webpack_public_path__ + "img/Aura_feather.10e3bad3.png";